import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { clsx } from 'clsx';

import { ProgressBarComponent, ProgressBarModel } from '../progress-bar/progress-bar.component';

export const titleSize = {
  BASE: 'base',
  XL: 'xl',
} as const;

export type TitleSize = (typeof titleSize)[keyof typeof titleSize];

const titleClass = {
  [titleSize.BASE]: clsx('mb-0 text-base'),
  [titleSize.XL]: clsx('mb-2 text-xl font-bold'),
};
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-checklist-progress-heading',
  templateUrl: './checklist-progress-heading.component.html',
  imports: [ProgressBarComponent],
})
export class ChecklistProgressHeadingComponent {
  title = input.required<string>();
  titleSize = input<TitleSize>(titleSize.BASE);
  progress = input<ProgressBarModel>();

  textSizeAttribute = computed(() => titleClass[this.titleSize()] || titleClass[titleSize.BASE]);
}
